import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import jobActions, { thunks as jobThunks } from '@redux/jobs';
import { thunks as officerThunks } from '@redux/officers';
import { Col, Grid } from 'react-bootstrap';
import {
	OfficerDetails, PingsMap, JobTimeDetails, FeedTimeLine,
} from '@components';
import { Loader, SubNavBar } from '@components/common';
import queryString from 'query-string';

class LocationDetails extends Component {
	constructor(props) {
		super(props);

		const { receiveData } = this.props;

		// Reset feed initial state
		receiveData([
			{ property : 'locationDetails.feed.list', value : [] },
			{ property : 'locationDetails.feed.pagingToken', value : '' },
			{ property : 'locationDetails.feed.hasNext', value : true },
		]);
	}

	componentDidMount() {
		const {
			jobId, search, getJobPoints, getOfficer, getOfficerJobFeeds,
		} = this.props;

		const { userId : officerId, positionId } = queryString.parse(search);

		getOfficer(officerId);
		getJobPoints(positionId, officerId);
		getOfficerJobFeeds(jobId, officerId);
	}

	shouldComponentUpdate({
		loadingJobPoints,
		locationDetails,
		loadingOfficer,
	}) {
		const lastProps = this.props;
		return (
			!isEqual(loadingJobPoints, lastProps.loadingJobPoints)
			|| !isEqual(loadingOfficer, lastProps.loadingOfficer)
			|| !isEqual(locationDetails, lastProps.locationDetails)
		);
	}

	onClickBack = (event) => {
		event.preventDefault();
		const { history } = this.props;
		history.goBack();
	}

	render() {
		const {
			TimeZoneId,
			officer,
			locationDetails,
			loadingJobPoints,
			loadingOfficer,
			loadingFeed,
			getOfficerJobFeeds,
			receiveData,
		} = this.props;

		const { points, job, feed } = locationDetails;

		return (
			<React.Fragment>
				<SubNavBar
					backText="Back to job"
					onClickBack={this.onClickBack}
				/>
				<Grid className="padded">
					<Col md={12}>
						<div className="flex flex-align-items-center">
							<div className="flex-auto font-size-24">Pings</div>
						</div>
						<div className="details-panel padding-0">
							<OfficerDetails
								officer={officer}
								timeZoneId={TimeZoneId}
							/>
							<div className="separator separator-solid" />
							<PingsMap
								locationDetails={locationDetails}
								timeZoneId={TimeZoneId}
								onClickItem={receiveData}
							/>
							<div className="padding-left-100 padding-right-60">
								<JobTimeDetails
									job={job}
									points={points}
									timeZoneId={TimeZoneId}
								/>
								<div className="separator separator-solid" />
								<FeedTimeLine
									feed={feed}
									timeZoneId={TimeZoneId}
									loading={loadingFeed}
									loadMore={getOfficerJobFeeds}
								/>
							</div>
						</div>
					</Col>
				</Grid>
				<Loader active={loadingJobPoints || loadingOfficer} />
			</React.Fragment>
		);
	}
}

const mapStateToProps = ({
	app : {
		user : { TimeZoneId },
	},
	router : {
		location : { search },
		match : {
			params : { id : jobId },
		},
	},
	jobs : {
		locationDetails,
		loaders : {
			jobPoints           : loadingJobPoints,
			locationDetailsFeed : loadingFeed,
		},
	},
	officers : {
		activeOfficer : officer,
		loaders : {
			activeOfficer : loadingOfficer,
		},
	},
}) => ({
	TimeZoneId,
	jobId,
	loadingJobPoints,
	loadingFeed,
	search,
	locationDetails,
	officer,
	loadingOfficer,
});

const mapDispatchToProps = (dispatch) => ({
	getJobPoints       : bindActionCreators(jobThunks, dispatch).getJobPoints,
	getOfficerJobFeeds : bindActionCreators(jobThunks, dispatch).getOfficerJobFeeds,
	receiveData        : bindActionCreators(jobActions, dispatch).receiveData,
	getOfficer         : bindActionCreators(officerThunks, dispatch).getById,
});

LocationDetails.propTypes = {
	TimeZoneId : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	getJobPoints       : PropTypes.func.isRequired,
	getOfficer         : PropTypes.func.isRequired,
	getOfficerJobFeeds : PropTypes.func.isRequired,
	history            : PropTypes.object.isRequired,
	jobId              : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	loadingFeed      : PropTypes.bool,
	loadingJobPoints : PropTypes.bool,
	loadingOfficer   : PropTypes.bool,
	locationDetails  : PropTypes.object,
	officer          : PropTypes.object,
	receiveData      : PropTypes.func.isRequired,
	search           : PropTypes.string,
};

LocationDetails.defaultProps = {
	TimeZoneId       : '',
	jobId            : '',
	loadingFeed      : false,
	loadingJobPoints : false,
	loadingOfficer   : false,
	locationDetails  : {},
	officer          : {},
	search           : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationDetails);
